let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dVM1q")).then(() => parcelRequire('5tKh7'));